// In development the app and API share an origin, so we hit the relative
// `/api` path. In production lite.subwaynow.app/api just redirects to
// api.subwaynow.app, so we call the API host directly to skip the redirect.
// Note: the API namespace is served at the root of api.subwaynow.app (no `/api`
// prefix), which is why the prod base omits it.
const API_BASE = process.env.NODE_ENV === 'production'
  ? 'https://api.subwaynow.app'
  : '/api';

export default API_BASE;
